import { GlSprintf } from '@gitlab/ui';
import { s__ } from '~/locale';
import ClipboardButton from '~/vue_shared/components/clipboard_button.vue';
import DetailsRow from '~/vue_shared/components/registry/details_row.vue';
export default {
    name: 'MetadataComposer',
    i18n: {
        targetShaCopyButton: s__('PackageRegistry|Copy target SHA'),
        targetSha: s__('PackageRegistry|Target SHA: %{sha}'),
        composerJson: s__('PackageRegistry|Composer.json with license: %{license} and version: %{version}')
    },
    components: {
        DetailsRow,
        GlSprintf,
        ClipboardButton
    },
    props: {
        packageMetadata: {
            type: Object,
            required: true
        }
    }
};
